import React from 'react'

/**
 * Rows-only skeleton for the open/archive task list. Rendered inside the
 * widget's scroll area, so the card chrome around it is drawn once by the
 * widget and nothing reflows when the rows resolve.
 */
function TasksListSkeleton({ rows = 3 }) {
    return (
        <div aria-hidden="true">
            {Array.from({ length: rows }).map((_, index) => (
                <div key={index} className="w-full p-5 my-2 bg-containerGray rounded-[10px]">
                    <div className="flex flex-row items-center gap-[10px]">
                        <div className="dsh-skeleton-block w-[24px] h-[24px] !rounded-full" />
                        <div className="dsh-skeleton-block h-4 w-[110px]" />
                        <div className="flex-1" />
                        <div className="dsh-skeleton-block h-4 w-[70px]" />
                    </div>
                    <div className="dsh-skeleton-block h-5 w-[65%] mt-[15px]" />
                </div>
            ))}
        </div>
    )
}

export default TasksListSkeleton
